module.exports = __webpack_public_path__ + "static/media/bgimg.4e6d5e19.png";